import { connect } from 'react-redux';
import PlayerListSettings from '../../components/Pages/PlayerListSettings';
import { setUserSetting } from '../../store/actions/userSettings';

const mapStateToProps = state => {

    return {
        context:            state.auth.context,
        playerListSettings: state.userSettings.playerListSettings || {}
    };

};

const mapDispatchToProps = dispatch => {

    return {

        onUpdatePlayerListSettings: e => dispatch( setUserSetting( 'playerListSettings', e ) )

    };

};

export default connect( mapStateToProps, mapDispatchToProps )( PlayerListSettings );